(function() {

  const startDate = "2025-11-01";
  const endDate = "2025-11-14";
  
  function checkBadgeVisibility() {

    if (!startDate || !endDate) {
      // document.documentElement.classList.add('hide-new-badge');
      return;
    }
    
    const now = new Date();
    const start = new Date(startDate);
    const end = new Date(endDate);
    
    now.setHours(0, 0, 0, 0);
    start.setHours(0, 0, 0, 0);
    end.setHours(23, 59, 59, 999);
    
    const isWithinRange = now >= start && now <= end;
    
    if (!isWithinRange) {
      document.documentElement.classList.add('hide-new-badge');
    } else {
      document.documentElement.classList.remove('hide-new-badge');
    }
  }
  
  // Run on page load
  checkBadgeVisibility();
})();


document.addEventListener("DOMContentLoaded", function () {
  const storageKey = "shopifyCollection";

  if (
    window.ShopifyPage.collection &&
    window.ShopifyPage.template.includes("collection")
  ) {
    localStorage.setItem(
      storageKey,
      JSON.stringify(window.ShopifyPage.collection)
    );
  } else {
    localStorage.setItem(
      storageKey,
      JSON.stringify({
        handle: "",
        title: ""
      })
    );
  }
});
